// frontend/admin-portal/src/routes/AppRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import AdminLayout from "../layouts/AdminLayout";

import {
  AuthRoutes,
  DashboardRoutes,
  CatalogRoutes,
  SupplierRoutes,
  ProcurementRoutes,
  SalesRoutes,
  TreasuryRoutes,
  SystemRoutes,
} from "./domains";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      {AuthRoutes()}

      {/* Authenticated shell */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {DashboardRoutes()}
        {CatalogRoutes()}
        {SupplierRoutes()}
        {ProcurementRoutes()}
        {SalesRoutes()}
        {TreasuryRoutes()}
        {SystemRoutes()}
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
